






















import { Component, Vue } from "vue-property-decorator";
import { IRootStoreState } from "../../store/root";

@Component
export default class ProjectFilter extends Vue {
  get allProjects(): string[] {
    // We could cache these, but filtering is the bottleneck so there is no point to bother
    return this.$store.getters["recommendationsStore/allProjects"];
  }

  get projectsSelected(): string[] {
    return (this.$store.state as IRootStoreState).coreTableStore!
      .projectsSelected;
  }

  set projectsSelected(projects: string[]) {
    this.$store.commit("coreTableStore/setProjectsSelected", projects);
  }
}
